import { Component, OnInit } from '@angular/core';
import { MatSnackBar } from '@angular/material';
import { FormBuilder, FormGroup, Validators, FormArray } from '@angular/forms';
import { AppSettings } from '../../app.constant';
import { CategoryService } from 'src/app/shared/services/category.service';
import { SponserService } from 'src/app/shared/services/sponser.service';
import { InstitutionService } from 'src/app/shared/services/institution.service';
import { ProgramService } from 'src/app/shared/services/program.service';
import { ModuleService } from 'src/app/shared/services/module.service';
import { BatchService } from 'src/app/shared/services/batch.service';
// import { SubjectService } from 'src/app/shared/services/subject.service';
import { StudentsService } from 'src/app/shared/services/students.service';
import { NotificationComponent } from 'src/app/private/widget/notification/notification.component';
import { Program } from 'src/app/shared/class/program';
import { Module } from 'src/app/shared/class/module';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material';
import { MomentDateAdapter } from '@angular/material-moment-adapter';

export const MY_FORMATS = {
  parse: {
    dateInput: 'LL',
  },
  display: {
    dateInput: 'DD/MM/YYYY',
    monthYearLabel: 'YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'YYYY',
  },
};

@Component({
  selector: 'app-student-registration',
  templateUrl: './student-registration.component.html',
  styleUrls: ['./student-registration.component.css'],
  providers: [
    { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
  ],
})


export class StudentRegistrationComponent implements OnInit {
  studentForm: FormGroup;
  categories: any;
  sponsers: any;
  Institutions: any;
  programs: any;
  modules: any;
  module: any;
  filtermodule: any;
  batches: any;
  errorMessage: String;
  gender: string;
  Gender: string[] = ['Male', 'Female'];
  public show: boolean = false;
  selectFiled: any;
  public resultdata: any;
  post: any;
  gradePoints;
  subjects: string;
  Subjects: any;
  enrolmentNo: any = '';
  EnrolmentNum: any = '';
  grades: string;
  minDate: string;
  maxDate: string;
  FK_ProgramID: any;
  data: any;
  msgData: any;
  LastName: any;
  EnrolmentNo: any;
  DateOfBirth: Date = new Date();
  //DateOfBirth: any;

  ResidentialAddress: any;
  PostalAddress: any;
  TelephoneNo: any;
  MobileNo: any;
  EmailID: any;
  District: any;
  Nationality: any;
  PassportNo: any;
  TownOfBirth: any;
  TRNo: any;
  ApplicationCode: any;
  ContactNum: any;
  FK_SponserID: any;
  FK_InstitutionID: any;
  FK_ModuleID: any;
  FK_CategoryID: any;
  FK_BatchID: any;
  PK_StudentID: any;
  Enrollment: any;

  // param:any;

  selectedProgram: Program = new Program(1, 'ABC', 'asd', 'sadasdsa');
  program: any;
  // Modules:Module[];
  varstring: string
  FirstName: any;

  constructor(
    private formbuilder: FormBuilder,
    private _categoryservice: CategoryService,
    private _sponserservice: SponserService,
    private _institutionservice: InstitutionService,
    private _programservice: ProgramService,
    private _moduleservice: ModuleService,
    private _batchservice: BatchService,
    private _studentsservice: StudentsService,
    // private _subjectservice: SubjectService,
    private snackBar: MatSnackBar,
  ) { }

  ngOnInit() {
    this.studentForm = this.formbuilder.group({
      'PK_StudentID': ['',],
      'FK_BatchID': ['', Validators],
      'FK_CategoryID': ['', Validators],
      'FK_InstitutionID': ['', Validators],
      'FK_SponserID': ['', Validators],
      'FK_ProgramID': ['', Validators],
      'FK_ModuleID': ['', Validators],
      'ApplicationCode': ['',],
      'EnrolmentNo': ['',],
      'FirstName': ['', Validators.required],
      'LastName': ['', [Validators.required,]],
      'DateOfBirth': ['',],
      'TownOfBirth': ['',],
      'ResidentialAddress': ['',],
      'PostalAddress': ['',],
      'TelephoneNo': ['',],
      'MobileNo': ['',],
      'EmailID': ['',],
      'District': ['',],
      'ContactNum': ['',],
      'TRNo': ['',],
      'Gender': ['',],
      'Nationality': ['',],
      'PassportNo': ['',],

      // 'BGCSECompletionYear': ['', [Validators.required, Validators.maxLength(10)]],
      // 'BGCSETotalPoints': ['', [Validators.required, Validators.maxLength(10)]],
      //'SignatureOfGuardian':['', Validators.required],
      // 'QualificationEntities': this.formbuilder.array([]),
      // 'BGCSEDetailEntities': this.formbuilder.array([]),
      // 'CoreSubjectEntities': this.formbuilder.array([]),
    })
    this.studentForm.reset();
    this.getallCategory();
    this.getAllSponser();
    this.getAllProgram();
    this.getAllInstitution();
    this.getStudentData();
  }

  getallCategory(): void {
    this._categoryservice.getAllCategory(AppSettings.API_ENDPOINT + AppSettings.GetAllCategory)
      .subscribe(data => {
        this.categories = data;
      },
        error => this.errorMessage = <any>error)
  }

  getAllSponser() {
    this._sponserservice.getAllSponsers(AppSettings.API_ENDPOINT + AppSettings.GetAllSponser)
      .subscribe(data => {
        this.sponsers = data;
        if (!data) {
          return;
        }
      });
  }

  getAllProgram(): void {
    this._programservice.getAllProgram(AppSettings.API_ENDPOINT + AppSettings.GetAllProgram).subscribe(
      data => {
        this.programs = data;
      },
      error => this.errorMessage = <any>error)
  }

  getAllInstitution() {
    this._institutionservice.getAllInstitution(AppSettings.API_ENDPOINT + AppSettings.GetAllInstitution)
      .subscribe(data => {
        this.Institutions = data;
      });
  }

  getModuleByProgramID(FK_ProgramID): void {
    this.FK_ProgramID = FK_ProgramID;
    var o = {
      PK_ProgramID: FK_ProgramID
    }
    this.post = JSON.stringify(o);

    this.getBatchByProgramID(FK_ProgramID);
    this._moduleservice.getModuleByProgramID(AppSettings.API_ENDPOINT + AppSettings.GetModuleByProgramID, this.post).subscribe(
      data => {
        this.modules = data;
        //this.modules= this.module.filter((item) => item.FK_ProgramID == PK_ProgramID);
      },
      error => this.errorMessage = <any>error)
  }

  getBatchByProgramID(PK_ProgramID): void {
    var o = { PK_ProgramID: PK_ProgramID }
    this.post = JSON.stringify(o);

    this._batchservice.GetBatchByProgramID(AppSettings.API_ENDPOINT + AppSettings.GetBatchByProgramID, this.post)
      .subscribe(
        data => {
          this.batches = data;
          // this.batches= this.batch.filter((item) => item.FK_ProgramID == PK_ProgramID);
        },
        error => this.errorMessage = <any>error)
  }

  postStudent(post): void {

    if (post.PK_StudentID != '' && post.PK_StudentID != null) {
      this.updateStudent(post);
    }
    else {
      this.createStudent(post);
    }
  }

  createStudent(post): void {
    if (this.studentForm.invalid) {
      return;
    }
    this.post = JSON.stringify(post);

    this._studentsservice.createStudent(AppSettings.API_ENDPOINT + AppSettings.CreateStudent, this.post).subscribe(
      data => {
        this.openSnackBar();
        this.studentForm.reset();
      },
      error => this.errorMessage = <any>error)
  }

  updateStudent(post): void {
    if (this.studentForm.invalid) {
      return;
    }
    this.post = JSON.stringify(post);
    this._studentsservice.updateStudent(AppSettings.API_ENDPOINT + AppSettings.UpdateStudent, this.post).subscribe(
      data => {

        this.openSnackBar();
        this.studentForm.reset();
      },
      error => this.errorMessage = <any>error)
  }

  getStudentData() {
    this._studentsservice.currentMessage
      .subscribe(
        message => {
          this.msgData = message;
          this.PK_StudentID = this.msgData.PK_StudentID;
          this.FirstName = this.msgData.FirstName;
          this.LastName = this.msgData.LastName;
          this.EnrolmentNo = this.msgData.EnrolmentNo;
          //this.DateOfBirth = new Date(Date.parse(this.msgData.DateOfBirth));
          this.DateOfBirth = this.msgData.DateOfBirth;
          this.ResidentialAddress = this.msgData.ResidentialAddress;
          this.PostalAddress = this.msgData.PostalAddress;
          this.TownOfBirth = this.msgData.TownOfBirth;
          this.TelephoneNo = this.msgData.TelephoneNo;
          this.MobileNo = this.msgData.MobileNo;
          this.EmailID = this.msgData.EmailID;
          this.District = this.msgData.District;
          this.Gender = this.msgData.Gender;
          this.Nationality = this.msgData.Nationality;
          this.PassportNo = this.msgData.PassportNo;
          this.TRNo = this.msgData.TRNo;
          this.ContactNum = this.msgData.ContactNum;
          this.ApplicationCode = this.msgData.ApplicationCode;
          this.FK_ProgramID = this.msgData.FK_ProgramID;
          this.FK_SponserID = this.msgData.FK_SponserID;
          this.FK_InstitutionID = this.msgData.FK_InstitutionID;
          this.FK_ModuleID = this.msgData.FK_ModuleID;
          this.FK_CategoryID = this.msgData.FK_CategoryID;
          this.FK_BatchID = this.msgData.FK_BatchID;

        });
  }

  getEnrollmentNo(FK_BatchID): void {
    var o = { PK_BatchID: FK_BatchID }
    this.post = JSON.stringify(o);
    this._batchservice.getEnrollment(AppSettings.API_ENDPOINT + AppSettings.GetBatchByParam, this.post).subscribe(
      data => {
        // this.enrolmentNo = data;
        if (!data)
          this.EnrolmentNo = data[0].Enrollment;
      },
      error => this.errorMessage = <any>error)
  }

  durationInSeconds = 5;
  openSnackBar() {
    this.snackBar.openFromComponent(NotificationComponent, {
      duration: this.durationInSeconds * 1000,
    });
  }

  public hasError = (controlName: string, errorName: string) => {
    return this.studentForm.controls[controlName].hasError(errorName);
  }

  // core subject
  // addnewSubject() {
  //   let control = <FormArray>this.studentForm.controls.CoreSubjectEntities;
  //   control.push(
  //     this.formbuilder.group({
  //       SubjectId: [],
  //       SubjectName: [],
  //       SubjectCode: [],
  //       Core: []
  //     })
  //   )
  // }

  // deleteSubject(index) {
  //   let control = <FormArray>this.studentForm.controls.CoreSubjectEntities;
  //   control.removeAt(index)
  // }

  // setCompanies() {
  //   let control = <FormArray>this.studentForm.controls.CoreSubjectEntities;

  //   for (let i = 0; i < control.length; i++) {
  //     control.removeAt(i)
  //   }
  //   this.data.forEach(x => {
  //     control.push(this.formbuilder.group({
  //       SubjectId: x.Subjectid,
  //       SubjectName: x.SubjectName,
  //       SubjectCode: x.SubjectCode,
  //       Core: x.Core
  //     }))
  //   });

  // }

  // get QualificationForm() {
  //   return this.studentForm.get('QualificationEntities') as FormArray
  // }

  // addQualification() {
  //   const qualificationFb = this.formbuilder.group({
  //     // PK_QualificationID:[],
  //     IstitutionName: [],
  //     Qualification: [],
  //     Grade: [],
  //     Year: []
  //   })
  //   this.QualificationForm.push(qualificationFb);
  // }

  // deleteQualification(i) {
  //   this.QualificationForm.removeAt(i)
  // }

  // // BGCSE
  // get BGCSEForm() {
  //   return this.studentForm.get('BGCSEDetailEntities') as FormArray
  // }

  // addbgcse() {
  //   const BGCSEfb = this.formbuilder.group({
  //     Subject: [],
  //     Grade: []
  //   })
  //   this.BGCSEForm.push(BGCSEfb);
  // }

  // deleteBGCSE(i) {
  //   this.BGCSEForm.removeAt(i)
  // }

  // addGrade() {
  //   this.gradePoints.push({
  //     subject: this.subjects,
  //     grade: this.grades
  //   })
  //   sessionStorage.setItem('loadGrades', JSON.stringify(this.gradePoints));
  // }

  // getSubjectByProgramIDModuleID(PK_ModuleID): void {
  //   var o = { PK_ModuleID: PK_ModuleID, FK_ProgramID: this.FK_ProgramID }
  //   this.post = JSON.stringify(o);
  //   this._subjectservice.getSubjectbyProgramID(AppSettings.API_ENDPOINT + AppSettings.GetSubjectByParam, this.post).subscribe(
  //     data => {
  //       this.data = data;
  //       this.setCompanies();
  //     },
  //     error => this.errorMessage = <any>error)
  // }

  // hide and show text filed
  showFiled(FK_CategoryID: any) {
    this.selectFiled = FK_CategoryID;
    if (FK_CategoryID == 1) {
      this.show = true;
    }
    else {
      this.show = false;
    }
  }

  // deleteGrade(gradepoints) {
  //   for (var i = 0; i < this.gradePoints.length; i++) {
  //     if (this.gradePoints[i]["subject"] === gradepoints) {
  //       this.gradePoints.splice(i, 1);
  //       sessionStorage.setItem('loadGrades', JSON.stringify(this.gradePoints));
  //     }
  //   }
  // }


}
